module.exports = __webpack_public_path__ + "static/media/angry.763a89f0.svg";